<template>
  <div class="notifications-list">
    <h4 class="form-header notifications-list__header">
      Notifications
    </h4>
    <div class="notifications-list__items" @scroll="onScroll" ref="container">
      <div class="notifications-list__items-container">
        <template v-for="({date, notifications}, idx) in notificationList" :key="date">
          <notifications-day-title :date="date" :class="{'first': idx === 0}" />
          <notification-item v-for="notification in notifications" :notification="notification"
                             @on-close="$emit('on-close')"
                             @add-to-unread="addToUnread"
                             :key="notification.uuid" />
        </template>
      </div>
    </div>
    <app-loader :size="!notificationData.length ? 'md' : 'sm'" v-if="isLoading" />
  </div>
</template>

<script>
import { dateFormatter } from "../../helpers/formatters";
import { clickableNotificationTypes } from "../../constants/notificationTypes";

import NotificationsService from "../../services/notificationsService";
import NotificationsDayTitle from "./NotificationsDayTitle";
import NotificationItem from "./NotificationItem";
import AppLoader from "../common/AppLoader";
import { DATE_FORMAT_SYSTEM } from '@/constants/dateFormats'

export default {
  components: {
    NotificationsDayTitle,
    NotificationItem,
    AppLoader,
  },
  data() {
    return {
      isLoading: false,
      notificationData: [],
      totalCount: 0,
      unreadNotifications: [],
    }
  },
  computed: {
    notificationList() {
      return this.notificationData.reduce((acc, current) => {

        const date = dateFormatter({ date: current.created_at, format: DATE_FORMAT_SYSTEM })

        const day = acc.find(d => d.date === date)

        const notification = { ...current, clickable: clickableNotificationTypes.includes(current.type) }

        if (day) {
          day.notifications.push(notification)
        } else {
          acc.push({ date, notifications: [notification] })
        }

        return acc
      }, []);
    },
  },
  methods: {
    async markAsRead() {
      try {
        await NotificationsService.markNotificationsAsRead(this.unreadNotifications)

        await this.$emit('get-unread-count')
      } catch (e) {
        console.error(e)
      }
    },
    async getList(offset = 0) {
      this.isLoading = true
      try {
        const {
          data: { count, results },
        } = await NotificationsService.getNotificationList({ offset })

        this.notificationData = this.notificationData.concat(results)
        this.totalCount = count
      } catch (e) {
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },
    addToUnread(uuid) {
      if (!this.unreadNotifications.includes(uuid)) {
        this.unreadNotifications.push(uuid)

        this.$emit('decrement-unread')
      }
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if ((Math.ceil(scrollTop) + Math.ceil(clientHeight) >= Math.ceil(scrollHeight)) &&
        (this.totalCount > this.notificationData.length &&
          !this.isLoading)) {
        this.getList(this.notificationData.length)
      }
    },
  },
  mounted() {
    this.getList()
  },
  unmounted() {
    this.markAsRead()
  },
}
</script>

<style lang="scss" scoped>
.notifications-list {
  width: 500px;
  max-height: 80vh;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 0 12px rgba(21, 46, 57, 0.12);
  position: absolute;
  right: -2px;
  top: 40px;
  z-index: 10001;
  flex-direction: column;
  display: flex;

  &__header {
    padding: 24px 0 0 20px;
    margin-bottom: 16px;
  }

  &__items {
    max-height: calc(100% - 66px);
    overflow: auto;
    padding: 0 12px;

    &-container {
      overflow-y: auto;
      height: 100%;
    }
  }

  :deep(.loader__wrapper) {
    position: static;

    .loader__spinner {
      &.md {
        margin-bottom: 24px;
      }
    }
  }
}
</style>
